// Baubeau — DISCOVER button: smooth-scrolls to the next section on the page
// (the native sections/product-list.liquid grid, placed right after the
// silhouette hero in templates/collection.silhouette.json). No scroll
// library, no dependency on the target section's internals — it just scrolls
// to the next sibling .shopify-section.
(function () {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-baubeau-discover]');
    if (!button) return;

    const currentSection = button.closest('.shopify-section');
    const target = currentSection?.nextElementSibling;
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
